import React, { Component } from "react";
import "../RegistrationCSS.css";
import AndtDTextBoxWrapper from "swfrontend/MDM/MDMAntdWrappers/TextBoxWrapper";
import {
  GSTValidator,
  PANValidator,
} from "../validators";

class AN22TaxationDetails extends Component {
  render() {
    const {
      formRef,
      gst_registration_status,
      isDisabled,
      validateGSTNumber,
      validateAadharNumber,
      aadharRequired,
      req_op_fields,
    } = this.props;

    return (
      <div className="row form-box">
        <legend className="form-legend">Taxation Details</legend>

        <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="pan_number"
            id="Pan Number"
            required={"pan_number" in req_op_fields["O"] ? false : true}
            disabled={"pan_number" in req_op_fields["S"] ? true : isDisabled}
            label="PAN Number"
            message="Enter Pan Number"
            placeholder="Enter Pan Number"
            validators={[{ validator: PANValidator }]}
            casetype="uppercase"
            maxlength={10}
            onChangeText={validateAadharNumber}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="gst_number"
            id="GST Number"
            required={
              "gst_number" in req_op_fields["O"]
                ? false
                : gst_registration_status
            }
            disabled={
              "gst_number" in req_op_fields["S"]
                ? true
                : isDisabled
                ? true
                : !gst_registration_status
            }
            label="GST Number"
            message="Enter GST Number"
            placeholder="Enter GST Number"
            validators={
              gst_registration_status ? [{ validator: GSTValidator }] : ""
            }
            onChangeText={validateGSTNumber}
            maxlength={15}
            casetype="uppercase"
            formRef={formRef}
          />
        </div>
      </div>
    );
  }
}

export default AN22TaxationDetails;
